import React, { useState, useEffect, useRef } from 'react';
import io from "socket.io-client";
import {
  FaSearch,
  FaFilter,
  FaChartBar,
  FaFileExport,
  FaPlus
} from 'react-icons/fa';
import Modal from 'react-modal';
import styles from './Pagamentos.module.css';
import NovoPagamentoModal from './NovoPagamentoModal';
import NovoReferenciaModal from './NovoReferenciaModal';
import Recibo, { gerarRecibo } from './Recibo';
import { useAuth } from '../../context/AuthContext';
import AlocacaoMensalModal from './AlocacaoMensalModal';
import { exportarPagamentos } from '../../utils/exportarPagamentos';
import RelatoriosPagamentos from './RelatoriosPagamentos';
import RelatorioReferencias from "./RelatorioReferencias";

const parseAmount = (valor) => {
  if (!valor) return 0;
  if (typeof valor === 'number') return valor;
  if (valor.includes(',')) {
    const limpo = valor.replace(/\./g, '').replace(',', '.');
    return parseFloat(limpo) || 0;
  }
  return parseFloat(valor) || 0;
};

const Pagamentos = () => {
  const { currentUser } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [newPaymentOpen, setNewPaymentOpen] = useState(false);
  const [newReferenceOpen, setNewReferenceOpen] = useState(false);
  const [showExportOptions, setShowExportOptions] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [detalhesModalOpen, setDetalhesModalOpen] = useState(false);
  const [payments, setPayments] = useState([]);
  const [reciboOpen, setReciboOpen] = useState(false);
  const [pagamentoSelecionado, setPagamentoSelecionado] = useState(null);
  const [alocacaoModalOpen, setAlocacaoModalOpen] = useState(false);
  const [dadosMensalidades, setDadosMensalidades] = useState([]);
  const [alunoSelecionado, setAlunoSelecionado] = useState(null);
  const [relatorioModalOpen, setRelatorioModalOpen] = useState(false);
  const [refSelecionada, setRefSelecionada] = useState('');

  const exportRef = useRef(null);

  const [filters, setFilters] = useState({
    year: 'all',
    month: 'all',
    type: 'all',
    status: 'all',
    class: 'all'
  });

  // abrir modal filtro
  const abrirModal = (pagamento) => {
    setSelectedPayment(pagamento);
    setModalIsOpen(true);
  };

  const fecharModal = () => {
    setModalIsOpen(false);
    setSelectedPayment(null);
  };

  const openRecibo = (payment) => {
    setPagamentoSelecionado(payment);
    setReciboOpen(true);
  };

  const closeRecibo = () => {
    setPagamentoSelecionado(null);
    setReciboOpen(false);
  };

  const abrirRelatorio = (aluno) => {
    setAlunoSelecionado(aluno);
    setRelatorioModalOpen(true);
  };

  const abrirDetalhesAlocacao = async (payment) => {
    try {
      const res = await fetch(`/api/pagamentos/alocacao/${payment.reference}`);
      const data = await res.json();

      if (res.ok) {
        setDadosMensalidades(data.mensalidades);
        setRefSelecionada(data.referencia);
        setAlocacaoModalOpen(true);
      } else {
        alert(data.message || "Este pagamento não tem detalhes mensais.");
      }
    } catch (err) {
      console.error("Erro ao buscar alocação:", err);
      alert("Erro ao conectar ao servidor.");
    }
  };

  const handleExportarPagamentos = (formato) => {
    if (!currentUser) {
      alert("Usuário não está logado ou dados indisponíveis.");
      return;
    }
    exportarPagamentos(
      filteredPayments,
      formato,
      "Relatório de Pagamentos",
      "pagamentos",
      "Escola Vida Abundante",
      "escolavidaabundante7gmail.com",
      "Matola, Machava Km 15 Nkomane",
      "700067254",
      currentUser.email,
      "Chaúca Creative"
    );
  };

  useEffect(() => {
    async function fetchPagamentos() {
      try {
        const response = await fetch("/api/pagamentos/todos");
        const data = await response.json();
        setPayments(data.pagamentos || []);
      } catch (err) {
        console.error("Erro ao buscar pagamentos:", err);
      }
    }
    fetchPagamentos();
  }, []);
  useEffect(() => {
  const socket = io(); // 👉 coloca o endereço do backend

  // Escuta evento do backend
  socket.on("pagamento_atualizado", ({ pagamento }) => {
    setPayments(prev => {
      const existe = prev.find(p => p?.id === pagamento?.id);
      if (existe) {
        // Atualiza status (pendente → pago)
        return prev.map(p => (p.id === pagamento.id ? pagamento : p));
      }
      // Se for novo, adiciona
      return [...prev, pagamento];
    });
  });

  return () => {
    socket.disconnect();
  };
}, []);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (exportRef.current && !exportRef.current.contains(e.target)) {
        setShowExportOptions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

const isFilterApplied = () => {
  return (
    filters.year !== 'all' ||
    filters.month !== 'all' ||
    filters.class !== 'all' ||
    filters.type !== 'all' ||
    filters.status !== 'all'
  );
};

const filteredPayments = isFilterApplied()
  ? payments.filter(payment => {
      const normalize = str =>
        str?.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

      const matchesSearch =
        (payment.student || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
        (payment.code || "").includes(searchQuery);

      const [day, month, year] = payment.datetime?.split(',')[0].split('/') || [];

      const matchesYear = filters.year === 'all' || year === filters.year;
      const matchesMonth = filters.month === 'all' || month === filters.month;
      const matchesType =
        filters.type === 'all' || (payment.type?.toLowerCase() === filters.type.toLowerCase());
      const matchesStatus =
        filters.status === 'all' || (payment.status?.toLowerCase() === filters.status.toLowerCase());
      const matchesClass =
        filters.class === 'all' || normalize(payment.class) === normalize(filters.class);

      return matchesSearch && matchesYear && matchesMonth &&
             matchesType && matchesStatus && matchesClass;
    })
  : payments; // exibe todos se nenhum filtro aplicado
  
const adicionarNovoPagamento = (novo) => {
  if (!novo || !novo.id) {
    console.warn("Pagamento inválido recebido:", novo);
    return;
  }

  setPayments(prev => [...prev, novo]);
};

  return (
    <div className={styles.pagamentosContainer}>
      <div className={styles.pagamentosHeader}>
        <h2>Gestão de Pagamentos</h2>
        <div className={styles.pagamentosActions}>
          <div className={styles.searchBar}>
            <FaSearch />
            <input placeholder="Pesquisar aluno ou código..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
          </div>
          <button className={styles.filterBtn} onClick={() => setModalIsOpen(true)}><FaFilter /> Filtrar</button>
          <div className={styles.dropdownExport} ref={exportRef}>
            <button className={styles.exportBtn} onClick={() => setShowExportOptions(prev => !prev)}>
              <FaFileExport /> Exportar
            </button>
            {showExportOptions && (
              <div className={styles.exportOptions}>
                <button onClick={() => handleExportarPagamentos('pdf')}>PDF</button>
                <button onClick={() => handleExportarPagamentos('excel')}>Excel</button>
                <button onClick={() => handleExportarPagamentos('csv')}>CSV</button>
              </div>
            )}
          </div>
          <button className={styles.reportBtn} onClick={() => abrirRelatorio(payments[0])}><FaChartBar /> Relatórios</button>
          <button className={styles.newReferenceBtn} onClick={() => setNewReferenceOpen(true)}><FaPlus /> Referencia</button>
          <button className={styles.newPaymentBtn} onClick={() => setNewPaymentOpen(true)}><FaPlus />Pagamento</button>
        </div>
      </div>

      <div className={styles.paymentsListScrollable}>
        <div className={styles.scrollWrapper}>
          <table className={styles.wideTable}>
            <thead>
              <tr>
                <th>Código</th><th>Aluno</th><th>Referência</th><th>Classe</th><th>Turma</th><th>Serviço</th>
                <th>Valor</th><th>Forma Pagamento</th><th>Data/Hora</th><th>Status</th><th>Detalhes</th><th>Ações</th>
              </tr>
            </thead>
            <tbody>
           {filteredPayments.length === 0 ? (
  <tr><td colSpan="12" className={styles.centerMsg}>
    {isFilterApplied() 
      ? "Nenhum pagamento encontrado com os filtros selecionados."
      : "Nenhum pagamento disponível."}
  </td></tr>
) : (
  filteredPayments.map(payment => (
    <tr key={payment.id}>
      <td>{payment.code}</td>
      <td>{payment.student}</td>
      <td>{payment.reference}</td>
      <td>{payment.class}</td>
      <td>{payment.turma || payment.nomeTurma || '—'}</td>
      <td>{payment.type?.toUpperCase()}</td>
      <td> {payment.amount ? Number(payment.amount).toFixed(2) : "0.00"} MZN</td>
      <td>{payment.paymentMethod}</td>
      <td>{payment.datetime}</td>
      <td><span className={`${styles.statusBadge} ${styles[payment.status]}`}>{payment.status}</span></td>
      <td>{payment.telefone_pagador || "—"}</td>
      <td>
        <button className={`${styles.actionBtn} ${styles.receipt}`} onClick={() => openRecibo(payment)}>
          Recibo
        </button>
      </td>
    </tr>
  ))
)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modais */}
      <NovoPagamentoModal isOpen={newPaymentOpen} onClose={() => setNewPaymentOpen(false)} onSave={adicionarNovoPagamento} />
      <NovoReferenciaModal isOpen={newReferenceOpen} onClose={() => setNewReferenceOpen(false)} />
      <AlocacaoMensalModal isOpen={alocacaoModalOpen} onClose={() => setAlocacaoModalOpen(false)} dadosMensalidades={dadosMensalidades} referencia={refSelecionada}/>
      
      {relatorioModalOpen && alunoSelecionado && (
        <RelatorioReferencias
          aluno={alunoSelecionado}
          pagamentos={payments.filter(p => p.code === alunoSelecionado.code)}
          onClose={() => setRelatorioModalOpen(false)} />)}

      {/* Modal do Recibo */}
      <Modal
        isOpen={reciboOpen}
        onRequestClose={closeRecibo}
        className={styles.reciboModal}
        overlayClassName={styles.modalOverlay}
      >
        <Recibo
          pagamento={pagamentoSelecionado}
          onClose={closeRecibo}
          onExport={() => gerarRecibo(pagamentoSelecionado)}
        />
      </Modal>

      {/* Modal filtro */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={fecharModal}
        className={styles.filterModal}
        overlayClassName={styles.modalOverlay}
      >
        <h2>Filtrar Pagamentos</h2>
        <div className={styles.modalContent}>
          <label>Ano:
            <select value={filters.year} onChange={e => setFilters({...filters, year: e.target.value})}>
              <option value="all">Todos</option>
              {[...Array(13)].map((_, i) => {
                const y = 2023 + i; return <option key={y} value={y}>{y}</option>;
              })}
            </select>
          </label>
          <label>Mês:
            <select value={filters.month} onChange={e => setFilters({...filters, month: e.target.value})}>
              <option value="all">Todos</option>
              {['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
                'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'].map((nome, i) => {
                const valor = String(i + 1).padStart(2, '0');
                return <option key={valor} value={valor}>{nome}</option>;
              })}
            </select>
          </label>
          <label>Classe:
            <select value={filters.class} onChange={e => setFilters({...filters, class: e.target.value})}>
              <option value="all">Todas</option>
              <option value="1ª Classe">1ª Classe</option>
              <option value="2ª Classe">2ª Classe</option>
              <option value="3ª Classe">3ª Classe</option>
              <option value="4ª Classe">4ª Classe</option>
              <option value="5ª Classe">5ª Classe</option>
              <option value="6ª Classe">6ª Classe</option>
              <option value="7ª Classe">7ª Classe</option>
              <option value="8ª Classe">8ª Classe</option>
              <option value="9ª Classe">9ª Classe</option>
              <option value="10ª Classe">10ª Classe</option>
              <option value="11ª Classe">11ª Classe</option>
              <option value="12ª Classe">12ª Classe</option>
            </select>
          </label>
          <label>Serviço:
            <select value={filters.type} onChange={e => setFilters({...filters, type: e.target.value})}>
           <option value="all">Todos</option>
           <option value="MATRICULA">Matrícula</option>
           <option value="RENOVACAO">Renovação</option>
           <option value="UNIFORME">Uniforme</option>
           <option value="CERTIFICADO">Certificado</option>
           <option value="DECLARACAO">Declaração</option>
          </select>
          </label>
          <label>Status:
            <select value={filters.status} onChange={e => setFilters({...filters, status: e.target.value})}>
              <option value="all">Todos</option>
              <option value="paid">Pago</option>
              <option value="pending">Pendente</option>
              <option value="overdue">Atrasado</option>
            </select>
          </label>

          <div className={styles.modalActions}>
            <button onClick={fecharModal}>Fechar</button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Pagamentos;
